// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,300,0,0);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PostSpeech_postContainer__Pmjsu {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  direction: rtl;
  background: linear-gradient(135deg, #f8fffe 0%, #f0f9f7 100%);
  min-height: fit-content;
}

.PostSpeech_postWrapper__fYs0p {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 8px 32px rgba(26, 95, 63, 0.15);
  border: 1px solid rgba(26, 95, 63, 0.08);
  margin-bottom: 40px;
}

/* Breadcrumb Navigation */
.PostSpeech_breadcrumb__Wi\\+E8 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 30px;
  font-size: 14px;
  color: #64748b;
  flex-wrap: wrap;
}

.PostSpeech_breadcrumbLink__32Lr1 {
  color: #1a5f3f;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}

.PostSpeech_breadcrumbLink__32Lr1:hover {
  color: #22543d;
  text-decoration: underline;
}

.PostSpeech_breadcrumbSeparator__HmvBy {
  color: #94a3b8;
  margin: 0 4px;
}

.PostSpeech_breadcrumbCurrent__EwUbb {
  color: #1e293b;
  font-weight: 600;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Category Badge - Speech Theme with Oili Green */
.PostSpeech_categoryBadge__dcKG2 {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);
  color: white;
  padding: 10px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 30px;
  box-shadow: 0 4px 12px rgba(26, 95, 63, 0.3);
}

.PostSpeech_categoryIcon__GPcaW img {
  width: 20px;
  height: 20px;
  filter: brightness(0) invert(1);
}

/* Post Header */
.PostSpeech_postHeader__PSvC5 {
  margin-bottom: 30px;
}

.PostSpeech_postTitle__4sb1V {
  font-size: 32px;
  font-weight: 700;
  color: #1a202c;
  line-height: 1.3;
  margin: 0;
  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Post Meta - Speech Theme with Oili Green */
.PostSpeech_postMeta__JJxhA {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 40px;
  padding: 20px;
  background: rgba(26, 95, 63, 0.05);
  border-radius: 16px;
  border: 1px solid rgba(26, 95, 63, 0.1);
  flex-wrap: wrap;
}

.PostSpeech_metaItem__kukk6 {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #475569;
  font-size: 14px;
  font-weight: 500;
}

.PostSpeech_metaIcon__GT4\\+Y {
  font-size: 16px;
  color: #1a5f3f;
}

.PostSpeech_metaText__DLgKt {
  color: #334155;
}

.PostSpeech_metaSeparator__gU3fV {
  color: #94a3b8;
  font-weight: bold;
}

/* Speech Media Section */
.PostSpeech_mediaSection__MnaZC {
  margin-bottom: 40px;
  text-align: center;
}

.PostSpeech_speechContainer__AzfHs {
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.15);
  border: 2px solid rgba(26, 95, 63, 0.1);
}

.PostSpeech_speechPlayer__Wn96w {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  max-width: 500px;
  margin: 0 auto;
}

.PostSpeech_speechThumbnail__5cux- {
  width: 120px;
  height: 120px;
  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.3);
  position: relative;
  overflow: hidden;
}

.PostSpeech_speechThumbnail__5cux-::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at center, rgba(255,255,255,0.2) 0%, transparent 70%);
}

.PostSpeech_speechIcon__rBk7P {
  width: 60px;
  height: 60px;
  filter: brightness(0) invert(1);
  z-index: 1;
  position: relative;
}

.PostSpeech_speechElement__N4oLg {
  width: 100%;
  height: 50px;
  border-radius: 25px;
  outline: none;
  background: white;
  box-shadow: 0 4px 15px rgba(26, 95, 63, 0.2);
}

.PostSpeech_speechElement__N4oLg::-webkit-media-controls-panel {
  background-color: white;
  border-radius: 25px;
}

.PostSpeech_mediaLoadingOverlay__-csik {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
}

.PostSpeech_mediaLoadingSpinner__Yp9tv {
  width: 40px;
  height: 40px;
  border: 3px solid #e2e8f0;
  border-top: 3px solid #1a5f3f;
  border-radius: 50%;
  animation: PostSpeech_spin__yCA5m 1s linear infinite;
}

.PostSpeech_defaultMediaContainer__v3K1d {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
  border-radius: 20px;
  border: 2px dashed rgba(26, 95, 63, 0.3);
}

/* .defaultMediaIcon {
  width: 80px;
  height: 80px;
  opacity: 0.6;
  filter: brightness(0) saturate(100%) invert(28%) sepia(24%) saturate(2476%) hue-rotate(128deg) brightness(94%) contrast(97%);
} */

.PostSpeech_speechesImage__ABUJj {
  width: 80%;
  height: 500px;
}

/* Post Content */
.PostSpeech_postContent__FHFVp {
  margin-bottom: 40px;
}

.PostSpeech_contentHtml__2uydQ,
.PostSpeech_contentText__-aaBv {
  font-size: 18px;
  line-height: 1.8;
  color: #334155;
  text-align: justify;
}

.PostSpeech_contentHtml__2uydQ h1,
.PostSpeech_contentHtml__2uydQ h2,
.PostSpeech_contentHtml__2uydQ h3 {
  color: #1a5f3f;
  margin-top: 2em;
  margin-bottom: 1em;
}

.PostSpeech_contentHtml__2uydQ p {
  margin-bottom: 1.5em;
}

.PostSpeech_contentHtml__2uydQ a {
  color: #1a5f3f;
  text-decoration: none;
  font-weight: 600;
}

.PostSpeech_contentHtml__2uydQ a:hover {
  text-decoration: underline;
}

/* Post Footer */
.PostSpeech_postFooter__2r2Fh {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 30px;
  border-top: 2px solid rgba(26, 95, 63, 0.1);
  flex-wrap: wrap;
  gap: 20px;
}

.PostSpeech_postStatus__tRNX8 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
}

.PostSpeech_statusIcon__I96M6 {
  font-size: 16px;
  color: #1a5f3f;
}

.PostSpeech_statusText__e\\+8V4 {
  color: #16a34a;
}

.PostSpeech_navigationActions__mlLO5 {
  display: flex;
  gap: 16px;
}

.PostSpeech_backToListButton__UCgQp {
  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);
  color: white;
  text-decoration: none;
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(26, 95, 63, 0.3);
}

.PostSpeech_backToListButton__UCgQp:hover {
  background: linear-gradient(135deg, #16543e 0%, #1f4e3a 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(26, 95, 63, 0.4);
}

/* Related Posts - Speech Theme with Oili Green */
.PostSpeech_relatedPostsSection__jq6R\\+ {
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 8px 32px rgba(26, 95, 63, 0.1);
  border: 1px solid rgba(26, 95, 63, 0.1);
}

.PostSpeech_relatedPostsTitle__pRVe\\+ {
  font-size: 24px;
  font-weight: 700;
  color: #1a5f3f;
  margin-bottom: 30px;
  text-align: center;
}

.PostSpeech_relatedPostsGrid__zZqKi {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.PostSpeech_relatedPostCard__dJx5w {
  display: block;
  background: white;
  border-radius: 16px;
  overflow: hidden;
  text-decoration: none;
  transition: all 0.3s ease;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.PostSpeech_relatedPostCard__dJx5w:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 28px rgba(26, 95, 63, 0.15);
  border-color: #1a5f3f;
}

.PostSpeech_relatedPostImage__B3Uks {
  height: 150px;
  overflow: hidden;
  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.PostSpeech_relatedPostImage__B3Uks img {
  width: 60px;
  height: 60px;
  filter: brightness(0) invert(1);
  transition: transform 0.3s ease;
}

.PostSpeech_relatedPostCard__dJx5w:hover .PostSpeech_relatedPostImage__B3Uks img {
  transform: scale(1.1);
}

.PostSpeech_relatedPostContent__prvlU {
  padding: 20px;
}

.PostSpeech_relatedPostTitle__hMNuu {
  font-size: 16px;
  font-weight: 600;
  color: #1a202c;
  margin: 0 0 8px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.PostSpeech_relatedPostDate__DDypb {
  font-size: 12px;
  color: #64748b;
  margin: 0;
}

/* Loading States */
.PostSpeech_loadingContainer__9f2DB {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
  border-radius: 20px;
  margin: 20px auto;
  max-width: 600px;
}

.PostSpeech_loadingSpinner__Dv8YO {
  width: 50px;
  height: 50px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid #1a5f3f;
  border-radius: 50%;
  animation: PostSpeech_spin__yCA5m 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes PostSpeech_spin__yCA5m {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.PostSpeech_loadingText__VBtLO {
  color: #1a5f3f;
  font-size: 18px;
  font-weight: 600;
}

/* Error States */
.PostSpeech_errorContainer__AGvr1,
.PostSpeech_notFoundContainer__5Yi-j {
  text-align: center;
  padding: 60px 40px;
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border-radius: 20px;
  margin: 20px auto;
  max-width: 600px;
  border: 1px solid #fca5a5;
}

.PostSpeech_errorIcon__NJC-q,
.PostSpeech_notFoundIcon__RqE0W {
  font-size: 60px;
  margin-bottom: 20px;
}

.PostSpeech_errorTitle__Q5Bd7,
.PostSpeech_notFoundTitle__tzVXM {
  font-size: 24px;
  font-weight: 700;
  color: #dc2626;
  margin-bottom: 16px;
}

.PostSpeech_errorMessage__HadbA,
.PostSpeech_notFoundMessage__TjH6J {
  font-size: 16px;
  color: #7f1d1d;
  margin-bottom: 30px;
  line-height: 1.6;
}

.PostSpeech_errorActions__FOIsU {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.PostSpeech_backButton__iPHWk,
.PostSpeech_retryButton__AB6Q3 {
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
  font-size: 14px;
}

.PostSpeech_backButton__iPHWk {
  background: #6b7280;
  color: white;
}

.PostSpeech_backButton__iPHWk:hover {
  background: #4b5563;
  transform: translateY(-2px);
}

.PostSpeech_retryButton__AB6Q3 {
  background: #dc2626;
  color: white;
}

.PostSpeech_retryButton__AB6Q3:hover {
  background: #b91c1c;
  transform: translateY(-2px);
}

/* Responsive Design */
@media (max-width: 768px) {
  .PostSpeech_postContainer__Pmjsu {
    padding: 15px;
  }

  .PostSpeech_postWrapper__fYs0p,
  .PostSpeech_relatedPostsSection__jq6R\\+ {
    padding: 25px;
  }

  .PostSpeech_postTitle__4sb1V {
    font-size: 24px;
  }

  .PostSpeech_postMeta__JJxhA {
    flex-direction: column;
    align-items: start;
    gap: 12px;
  }

  .PostSpeech_postFooter__2r2Fh {
    flex-direction: column;
    text-align: center;
  }

  .PostSpeech_relatedPostsGrid__zZqKi {
    grid-template-columns: 1fr;
  }

  .PostSpeech_speechThumbnail__5cux- {
    width: 100px;
    height: 100px;
  }

  .PostSpeech_speechIcon__rBk7P {
    width: 50px;
    height: 50px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Posts pages/PostSpeech.module.css"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,cAAc;EACd,6DAA6D;EAC7D,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,6CAA6C;EAC7C,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,kDAAkD;AAClD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,6CAA6C;EAC7C,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,wFAAwF;AAC1F;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,oDAAkC;AACpC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;;;;;GAKG;;AAEH;EACE,UAAU;EACV,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,2CAA2C;EAC3C,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,iDAAiD;AACjD;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,4CAA4C;EAC5C,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,6DAA6D;EAC7D,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,oDAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,300,0,0\");\r\n\r\n.postContainer {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n  direction: rtl;\r\n  background: linear-gradient(135deg, #f8fffe 0%, #f0f9f7 100%);\r\n  min-height: fit-content;\r\n}\r\n\r\n.postWrapper {\r\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\r\n  border-radius: 20px;\r\n  padding: 40px;\r\n  box-shadow: 0 8px 32px rgba(26, 95, 63, 0.15);\r\n  border: 1px solid rgba(26, 95, 63, 0.08);\r\n  margin-bottom: 40px;\r\n}\r\n\r\n/* Breadcrumb Navigation */\r\n.breadcrumb {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-bottom: 30px;\r\n  font-size: 14px;\r\n  color: #64748b;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.breadcrumbLink {\r\n  color: #1a5f3f;\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n  transition: color 0.3s ease;\r\n}\r\n\r\n.breadcrumbLink:hover {\r\n  color: #22543d;\r\n  text-decoration: underline;\r\n}\r\n\r\n.breadcrumbSeparator {\r\n  color: #94a3b8;\r\n  margin: 0 4px;\r\n}\r\n\r\n.breadcrumbCurrent {\r\n  color: #1e293b;\r\n  font-weight: 600;\r\n  max-width: 200px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Category Badge - Speech Theme with Oili Green */\r\n.categoryBadge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);\r\n  color: white;\r\n  padding: 10px 16px;\r\n  border-radius: 20px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  margin-bottom: 30px;\r\n  box-shadow: 0 4px 12px rgba(26, 95, 63, 0.3);\r\n}\r\n\r\n.categoryIcon img {\r\n  width: 20px;\r\n  height: 20px;\r\n  filter: brightness(0) invert(1);\r\n}\r\n\r\n/* Post Header */\r\n.postHeader {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.postTitle {\r\n  font-size: 32px;\r\n  font-weight: 700;\r\n  color: #1a202c;\r\n  line-height: 1.3;\r\n  margin: 0;\r\n  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n}\r\n\r\n/* Post Meta - Speech Theme with Oili Green */\r\n.postMeta {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n  margin-bottom: 40px;\r\n  padding: 20px;\r\n  background: rgba(26, 95, 63, 0.05);\r\n  border-radius: 16px;\r\n  border: 1px solid rgba(26, 95, 63, 0.1);\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.metaItem {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  color: #475569;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n}\r\n\r\n.metaIcon {\r\n  font-size: 16px;\r\n  color: #1a5f3f;\r\n}\r\n\r\n.metaText {\r\n  color: #334155;\r\n}\r\n\r\n.metaSeparator {\r\n  color: #94a3b8;\r\n  font-weight: bold;\r\n}\r\n\r\n/* Speech Media Section */\r\n.mediaSection {\r\n  margin-bottom: 40px;\r\n  text-align: center;\r\n}\r\n\r\n.speechContainer {\r\n  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);\r\n  border-radius: 20px;\r\n  padding: 30px;\r\n  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.15);\r\n  border: 2px solid rgba(26, 95, 63, 0.1);\r\n}\r\n\r\n.speechPlayer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 20px;\r\n  max-width: 500px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.speechThumbnail {\r\n  width: 120px;\r\n  height: 120px;\r\n  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.3);\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.speechThumbnail::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: radial-gradient(circle at center, rgba(255,255,255,0.2) 0%, transparent 70%);\r\n}\r\n\r\n.speechIcon {\r\n  width: 60px;\r\n  height: 60px;\r\n  filter: brightness(0) invert(1);\r\n  z-index: 1;\r\n  position: relative;\r\n}\r\n\r\n.speechElement {\r\n  width: 100%;\r\n  height: 50px;\r\n  border-radius: 25px;\r\n  outline: none;\r\n  background: white;\r\n  box-shadow: 0 4px 15px rgba(26, 95, 63, 0.2);\r\n}\r\n\r\n.speechElement::-webkit-media-controls-panel {\r\n  background-color: white;\r\n  border-radius: 25px;\r\n}\r\n\r\n.mediaLoadingOverlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(255, 255, 255, 0.9);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 20px;\r\n}\r\n\r\n.mediaLoadingSpinner {\r\n  width: 40px;\r\n  height: 40px;\r\n  border: 3px solid #e2e8f0;\r\n  border-top: 3px solid #1a5f3f;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n.defaultMediaContainer {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 300px;\r\n  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);\r\n  border-radius: 20px;\r\n  border: 2px dashed rgba(26, 95, 63, 0.3);\r\n}\r\n\r\n/* .defaultMediaIcon {\r\n  width: 80px;\r\n  height: 80px;\r\n  opacity: 0.6;\r\n  filter: brightness(0) saturate(100%) invert(28%) sepia(24%) saturate(2476%) hue-rotate(128deg) brightness(94%) contrast(97%);\r\n} */\r\n\r\n.speechesImage {\r\n  width: 80%;\r\n  height: 500px;\r\n}\r\n\r\n/* Post Content */\r\n.postContent {\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.contentHtml,\r\n.contentText {\r\n  font-size: 18px;\r\n  line-height: 1.8;\r\n  color: #334155;\r\n  text-align: justify;\r\n}\r\n\r\n.contentHtml h1,\r\n.contentHtml h2,\r\n.contentHtml h3 {\r\n  color: #1a5f3f;\r\n  margin-top: 2em;\r\n  margin-bottom: 1em;\r\n}\r\n\r\n.contentHtml p {\r\n  margin-bottom: 1.5em;\r\n}\r\n\r\n.contentHtml a {\r\n  color: #1a5f3f;\r\n  text-decoration: none;\r\n  font-weight: 600;\r\n}\r\n\r\n.contentHtml a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Post Footer */\r\n.postFooter {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding-top: 30px;\r\n  border-top: 2px solid rgba(26, 95, 63, 0.1);\r\n  flex-wrap: wrap;\r\n  gap: 20px;\r\n}\r\n\r\n.postStatus {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n\r\n.statusIcon {\r\n  font-size: 16px;\r\n  color: #1a5f3f;\r\n}\r\n\r\n.statusText {\r\n  color: #16a34a;\r\n}\r\n\r\n.navigationActions {\r\n  display: flex;\r\n  gap: 16px;\r\n}\r\n\r\n.backToListButton {\r\n  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);\r\n  color: white;\r\n  text-decoration: none;\r\n  padding: 12px 24px;\r\n  border-radius: 12px;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 4px 12px rgba(26, 95, 63, 0.3);\r\n}\r\n\r\n.backToListButton:hover {\r\n  background: linear-gradient(135deg, #16543e 0%, #1f4e3a 100%);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 16px rgba(26, 95, 63, 0.4);\r\n}\r\n\r\n/* Related Posts - Speech Theme with Oili Green */\r\n.relatedPostsSection {\r\n  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);\r\n  border-radius: 20px;\r\n  padding: 40px;\r\n  box-shadow: 0 8px 32px rgba(26, 95, 63, 0.1);\r\n  border: 1px solid rgba(26, 95, 63, 0.1);\r\n}\r\n\r\n.relatedPostsTitle {\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  color: #1a5f3f;\r\n  margin-bottom: 30px;\r\n  text-align: center;\r\n}\r\n\r\n.relatedPostsGrid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\r\n  gap: 20px;\r\n}\r\n\r\n.relatedPostCard {\r\n  display: block;\r\n  background: white;\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n  text-decoration: none;\r\n  transition: all 0.3s ease;\r\n  border: 1px solid #e2e8f0;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.relatedPostCard:hover {\r\n  transform: translateY(-4px);\r\n  box-shadow: 0 12px 28px rgba(26, 95, 63, 0.15);\r\n  border-color: #1a5f3f;\r\n}\r\n\r\n.relatedPostImage {\r\n  height: 150px;\r\n  overflow: hidden;\r\n  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.relatedPostImage img {\r\n  width: 60px;\r\n  height: 60px;\r\n  filter: brightness(0) invert(1);\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.relatedPostCard:hover .relatedPostImage img {\r\n  transform: scale(1.1);\r\n}\r\n\r\n.relatedPostContent {\r\n  padding: 20px;\r\n}\r\n\r\n.relatedPostTitle {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: #1a202c;\r\n  margin: 0 0 8px 0;\r\n  line-height: 1.4;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n}\r\n\r\n.relatedPostDate {\r\n  font-size: 12px;\r\n  color: #64748b;\r\n  margin: 0;\r\n}\r\n\r\n/* Loading States */\r\n.loadingContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 400px;\r\n  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);\r\n  border-radius: 20px;\r\n  margin: 20px auto;\r\n  max-width: 600px;\r\n}\r\n\r\n.loadingSpinner {\r\n  width: 50px;\r\n  height: 50px;\r\n  border: 4px solid #e2e8f0;\r\n  border-top: 4px solid #1a5f3f;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n.loadingText {\r\n  color: #1a5f3f;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Error States */\r\n.errorContainer,\r\n.notFoundContainer {\r\n  text-align: center;\r\n  padding: 60px 40px;\r\n  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);\r\n  border-radius: 20px;\r\n  margin: 20px auto;\r\n  max-width: 600px;\r\n  border: 1px solid #fca5a5;\r\n}\r\n\r\n.errorIcon,\r\n.notFoundIcon {\r\n  font-size: 60px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.errorTitle,\r\n.notFoundTitle {\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  color: #dc2626;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.errorMessage,\r\n.notFoundMessage {\r\n  font-size: 16px;\r\n  color: #7f1d1d;\r\n  margin-bottom: 30px;\r\n  line-height: 1.6;\r\n}\r\n\r\n.errorActions {\r\n  display: flex;\r\n  gap: 16px;\r\n  justify-content: center;\r\n}\r\n\r\n.backButton,\r\n.retryButton {\r\n  padding: 12px 24px;\r\n  border-radius: 12px;\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n  transition: all 0.3s ease;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n}\r\n\r\n.backButton {\r\n  background: #6b7280;\r\n  color: white;\r\n}\r\n\r\n.backButton:hover {\r\n  background: #4b5563;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.retryButton {\r\n  background: #dc2626;\r\n  color: white;\r\n}\r\n\r\n.retryButton:hover {\r\n  background: #b91c1c;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n  .postContainer {\r\n    padding: 15px;\r\n  }\r\n\r\n  .postWrapper,\r\n  .relatedPostsSection {\r\n    padding: 25px;\r\n  }\r\n\r\n  .postTitle {\r\n    font-size: 24px;\r\n  }\r\n\r\n  .postMeta {\r\n    flex-direction: column;\r\n    align-items: start;\r\n    gap: 12px;\r\n  }\r\n\r\n  .postFooter {\r\n    flex-direction: column;\r\n    text-align: center;\r\n  }\r\n\r\n  .relatedPostsGrid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .speechThumbnail {\r\n    width: 100px;\r\n    height: 100px;\r\n  }\r\n\r\n  .speechIcon {\r\n    width: 50px;\r\n    height: 50px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"postContainer": `PostSpeech_postContainer__Pmjsu`,
	"postWrapper": `PostSpeech_postWrapper__fYs0p`,
	"breadcrumb": `PostSpeech_breadcrumb__Wi+E8`,
	"breadcrumbLink": `PostSpeech_breadcrumbLink__32Lr1`,
	"breadcrumbSeparator": `PostSpeech_breadcrumbSeparator__HmvBy`,
	"breadcrumbCurrent": `PostSpeech_breadcrumbCurrent__EwUbb`,
	"categoryBadge": `PostSpeech_categoryBadge__dcKG2`,
	"categoryIcon": `PostSpeech_categoryIcon__GPcaW`,
	"postHeader": `PostSpeech_postHeader__PSvC5`,
	"postTitle": `PostSpeech_postTitle__4sb1V`,
	"postMeta": `PostSpeech_postMeta__JJxhA`,
	"metaItem": `PostSpeech_metaItem__kukk6`,
	"metaIcon": `PostSpeech_metaIcon__GT4+Y`,
	"metaText": `PostSpeech_metaText__DLgKt`,
	"metaSeparator": `PostSpeech_metaSeparator__gU3fV`,
	"mediaSection": `PostSpeech_mediaSection__MnaZC`,
	"speechContainer": `PostSpeech_speechContainer__AzfHs`,
	"speechPlayer": `PostSpeech_speechPlayer__Wn96w`,
	"speechThumbnail": `PostSpeech_speechThumbnail__5cux-`,
	"speechIcon": `PostSpeech_speechIcon__rBk7P`,
	"speechElement": `PostSpeech_speechElement__N4oLg`,
	"mediaLoadingOverlay": `PostSpeech_mediaLoadingOverlay__-csik`,
	"mediaLoadingSpinner": `PostSpeech_mediaLoadingSpinner__Yp9tv`,
	"spin": `PostSpeech_spin__yCA5m`,
	"defaultMediaContainer": `PostSpeech_defaultMediaContainer__v3K1d`,
	"speechesImage": `PostSpeech_speechesImage__ABUJj`,
	"postContent": `PostSpeech_postContent__FHFVp`,
	"contentHtml": `PostSpeech_contentHtml__2uydQ`,
	"contentText": `PostSpeech_contentText__-aaBv`,
	"postFooter": `PostSpeech_postFooter__2r2Fh`,
	"postStatus": `PostSpeech_postStatus__tRNX8`,
	"statusIcon": `PostSpeech_statusIcon__I96M6`,
	"statusText": `PostSpeech_statusText__e+8V4`,
	"navigationActions": `PostSpeech_navigationActions__mlLO5`,
	"backToListButton": `PostSpeech_backToListButton__UCgQp`,
	"relatedPostsSection": `PostSpeech_relatedPostsSection__jq6R+`,
	"relatedPostsTitle": `PostSpeech_relatedPostsTitle__pRVe+`,
	"relatedPostsGrid": `PostSpeech_relatedPostsGrid__zZqKi`,
	"relatedPostCard": `PostSpeech_relatedPostCard__dJx5w`,
	"relatedPostImage": `PostSpeech_relatedPostImage__B3Uks`,
	"relatedPostContent": `PostSpeech_relatedPostContent__prvlU`,
	"relatedPostTitle": `PostSpeech_relatedPostTitle__hMNuu`,
	"relatedPostDate": `PostSpeech_relatedPostDate__DDypb`,
	"loadingContainer": `PostSpeech_loadingContainer__9f2DB`,
	"loadingSpinner": `PostSpeech_loadingSpinner__Dv8YO`,
	"loadingText": `PostSpeech_loadingText__VBtLO`,
	"errorContainer": `PostSpeech_errorContainer__AGvr1`,
	"notFoundContainer": `PostSpeech_notFoundContainer__5Yi-j`,
	"errorIcon": `PostSpeech_errorIcon__NJC-q`,
	"notFoundIcon": `PostSpeech_notFoundIcon__RqE0W`,
	"errorTitle": `PostSpeech_errorTitle__Q5Bd7`,
	"notFoundTitle": `PostSpeech_notFoundTitle__tzVXM`,
	"errorMessage": `PostSpeech_errorMessage__HadbA`,
	"notFoundMessage": `PostSpeech_notFoundMessage__TjH6J`,
	"errorActions": `PostSpeech_errorActions__FOIsU`,
	"backButton": `PostSpeech_backButton__iPHWk`,
	"retryButton": `PostSpeech_retryButton__AB6Q3`
};
export default ___CSS_LOADER_EXPORT___;
